<template >
  <div name="attenance">

    <div v-if="errored" class="empty">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div class="h-screen max-h-screen overflow-y-auto">
    
    <!-- <h5 class="font-bold">Original content</h5>
    <section class="text-xs text-gray-500 border-b pb-2" v-html="lesson.introduction" /> -->

    <div class="flex justify-between">
      <h5 class="font-bold my-3">{{  displayField.name }}</h5>
      <button @click="showAdditionWindow = true" class="text-xs mr-3 text-orange-500 hover:opacity-50 focus:outline-none">View original</button>
      
    </div>
    
    <section class="text-xs text-gray-500 h-2/3 ">

        <vue-editor
            v-model="alteredContent"
            :editorToolbar="customToolbar"
            id="grid-outline"
            style="height:88%;"
            class="pr-4 mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
            placeholder="Type or copy and paste your outlines here"
          ></vue-editor>


      </section>

      <div class="w-full flex items-start justify-between px-3 pl-4 pt-3 pb-2">
              <div class="text-gray-600" v-if="1===3"> 
                {{ privateTitle }}
                <button
              type="button"
              class="
                hover:bg-gray-400 hover:bg-opacity-50
                px-3
                py-1
                rounded
                ml-2
              "
              v-bind:class="[
                postPrivate === 1
                  ? 'bg-yellow-600 bg-opacity-75 text-white'
                  : 'bg-green-400 text-white',
              ]"
              @click="checkboxToggle()"
            >
              <i
                class="fas"
                v-bind:class="
                  postPrivate === 1 ? 'fa-lock' : 'fa-check-circle'
                "
              ></i>
            </button>
              </div>

              <div class="-mr-1 flex space-x-3">
                <button v-if="hasAlteredLesson"
                @click="deleteEdit()"
                  type="submit"
                  class="publish-button bg-red-500 text-white font-medium py-1 px-4 rounded-lg tracking-wide mr-1 hover:bg-opacity-50"
                >Delete Edit</button>
                <button
                @click="saveAltered()"
                  type="submit"
                  class="publish-button bg-white text-gray-700 font-medium py-1 px-4 border border-gray-400 rounded-lg tracking-wide mr-1 hover:bg-gray-100"
                >Update Lesson</button>
              </div>
            </div>

    </div>

    <div v-show="showAdditionWindow" class="">
      <transition name="slidesecond">
        <div >
          <div class="sidesecond sm:w-full md:w-95p" v-on:click.prevent>
            <div
              class="py-2 flex justify-between items-center border-b border-gray-200 pl-6 bg-gray-200"
            >
              <div class="pl-2 flex content-center">
                <div class="text-lg pr-2 text-base text-purple-700">
                  <slot name="header-icon">
                    <i class="fas fa-file-contract"></i
                  ></slot>
                </div>

                <div class="font-bold text-base pl-2">
                  <slot name="header-title">
                    Original content @ {{  displayField.name  }}
                    <div class="text-xs">
                  
                    </div>
                  </slot>
                </div>
              </div>

              <div class="w-32 pr-6 text-right">
                <div class="flex items-center float-right">
                  <div class="pr-6">
                    <slot name="header-action"></slot>
                  </div>
                  <button
                    class="text-2xl focus:outline-none"
                    @click="showAdditionWindow = false"
                  >
                    <i
                      class="fas fa-times text-lg pl-4 hover:opacity-75"
                      title="Close"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="p-3 pt-4 text-sm h-80p  overflow-y-auto">
              <slot name="body" class="">
        
                <span class="text-gray-600" v-html="originalContent"/>

              </slot>
            </div>
          </div>
        </div>
        </transition>
        </div>
   
  </div>
</template>

  <script>
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";

import { SchoolService } from "@/services/school.service";

export default {
  name: "attenance",
  props: {
    lesson: Object,
    altered: Object,
    displayField: Object,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    hasAlteredLesson() {
      return this.altered != undefined
    },
    privateTitle() {
      return this.postPrivate === 1 ? "Edits are private" : "Viewable to all"
    },
    originalContent() {
      let vm = this
      console.log(this.displayField.model)
        var content = (function (field) {
        switch (field) {
          case "introduction":
            return vm.lesson.introduction != null ? vm.lesson.introduction : "" ;
          case "warm-up":
            return vm.lesson.warmup != null ? vm.lesson.warmup : "";
          case "game-session":
            return vm.lesson.gamecontent != null ? vm.lesson.gamecontent : "";
          case "main-session":
            return vm.lesson.maincontent != null ? vm.lesson.maincontent : "";
          case "competition":
            return vm.lesson.competition != null ? vm.lesson.competition : "";
          case "conclusion":
            return vm.lesson.conclusion != null ? vm.lesson.conclusion : "";
          case "activities":
            return vm.lesson.activities != null ? vm.lesson.activities : "";
          case "health":
            return vm.lesson.health != null ? vm.lesson.health : "";
          case "performance":
            return vm.lesson.performance != null ? vm.lesson.performance : "";
          case "collaboration":
            return vm.lesson.collaboration != null ? vm.lesson.collaboration : "";
          default:
            return vm.lesson.outline != null ? vm.lesson.outline : "";
        }
      })(this.displayField.model);
      return content;
    }
  },
  data: function () {
    return {
      errored: false,
      isSaving: false,
      alteredContent: "",
      postPrivate: 0,
      showAdditionWindow: false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["code-block"],
        ["clean"],
      ],
    };
  },
  created() {
   
  },
  mounted() {
    if (this.hasAlteredLesson) {
      this.alteredContent = this.altered.detail
    }
  },
  methods: {
    checkboxToggle() {
      if (this.postPrivate === 0) {
        this.postPrivate = 1 
      } else {
        this.postPrivate = 0
      }
    },
    processDelete() {
      if (!this.hasAlteredLesson) { return }

      this.isSaving = true;
      SchoolService.delete("/lessons/altered", this.altered.identifier, null)
          .then((response) => this.completion())
          .catch((err) => {
            this.failure(err)
          })
          .finally(() => (this.isSaving = false));
    },
    deleteEdit() {
      this.$swal({
        title: "Are you sure you want to delete?",
        text: "You will not be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete!",
      }).then((result) => {
        if (result) {
          this.processDelete();
        }
      });
    },
    completion() {
      this.alteredContent = ""
      this.postPrivate = 0
      this.$emit("refresh")
    },
    failure(error) {
      this.errored = true;
      console.log(" update error " + error);
    },
    saveAltered() {
      if (this.altered != undefined) {
        var object = this.altered
        object.detail = this.alteredContent
        object.share_level = this.postPrivate

        SchoolService.update("lessons/altered", object.identifier, object)
        .then((response) => {
            this.completion();
          })
        .catch( (err) => {
            this.failure(err);
          }
        );
      } else {

        let payload = {
          display_key: this.displayField.model,
          detail: this.alteredContent,
          lesson_id: this.lesson.id,
          share_level: this.postPrivate,
          user_id: this.currentUser.teacherID,
        };

        SchoolService.create("lessons/altered", payload)
          .then((response) => {
            this.completion();
          })
          .catch((err) => {
            console.log(err);
            this.failure(err);
          });
      }
    },
  },
  components: {
    VueEditor,
  },
};
</script>

<style scoped>


.slidesecond-enter-active {
  transition: all 0.85s ease-out;
}

.slidesecond-leave-active {
  transition: all 0.45s ease-out;
}
.slide-econd-enter-to {
  right: 0;
}
.slidesecond-enter-from {
  right: -100%;
}
.slidesecond-leave-to {
  right: -100%;
}
.slidesecond-leave-from {
  right: 0;
}

.slidesecond-leave-active,
.slidesecond-enter-active {
  transition: 0.4s ease;
}

.slidesecond-enter {
  transform: translate(100%, 0);
}
.slidesecond-leave-to {
  transform: translate(-100%, 0);
}

.sidesecond {
  z-index: 101;
  position: absolute;
  top: 0;
  right: 0;
  background: #fff;
  height: 100%;
  opacity: 1 !important;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
}
</style>